/**
 * @typedef {{ icon, label, color, onClick, isActive, sublabel, quantity }} TabOptions
 */


import "../../styles/widgets/widgets.css";

/**
 * 
 * @param {{ tabs: TabOptions[] }} param0 
 * @returns 
 */
export function Tabs({ tabs }) {

    return <div className="tabs">
        {
            tabs.map((tab, i) => {
                let { icon, label, color, onClick, isActive, sublabel, quantity } = tab;
                
                if(!color) color = "#333";

                return <div key={i} className={"tab-item" + (isActive ? " active" : "")} onClick={onClick}>
                    { icon ? <div className="icon-section">
                            <img src={icon} alt=""/>
                        </div> : [] }
                    <div className="label-section">
                        <div className="label" style={{ color }}>{label}</div>
                        { sublabel ? <div className="sublabel">{sublabel}</div> : [] }
                        { quantity ? <div className="quantity">{quantity}</div> : [] }
                    </div>
                </div>;
            })
        }
    </div>
    
}

